export default "__VITE_ASSET__KuLps9Dl__"